import React, { Component } from 'react';
import Draggable from 'react-draggable';
import Paper from 'material-ui/Paper';

class Board extends Component {
    // constructor(args) {
    //     super(args);
    //     console.log(args.match.params.orgId);
    // };

    render = () => {
        return (
            <main>
                <div>Board: {this.props.match.params.orgID} {this.props.match.params.boardID}</div>
                <Draggable>
                    <Paper>I can now be moved around!</Paper>
                </Draggable>
            </main>
        )
    };
};

export default Board;


// WEBPACK FOOTER //
// ./src/components/Board.js